import React from 'react';
import { Link } from 'react-router-dom';

export default function DisclosurePage() {
  return (
    <div className="page-container disclosure-page" data-testid="disclosure-page">
      <div className="crumbs">
        <Link to="/">Home</Link>
        <span>/</span>
        <span>Disclosure</span>
      </div>
      <h1 className="page-title">Disclosure &amp; transparency</h1>
      <p className="muted" style={{ marginBottom: 24 }}>
        Last updated: February 2026
      </p>

      <section className="disclosure-block">
        <h2>Affiliate links</h2>
        <p>
          Some tools listed on AI Framework include affiliate links. If you sign up for a
          paid plan through one of these links, we may earn a commission — at no extra
          cost to you.
        </p>
        <p>
          Affiliate status <strong>never</strong> affects whether a tool appears in the
          directory, its category, its editorial rating, or where it ranks in the tree.
          We only add tools we believe are worth checking out.
        </p>
      </section>

      <section className="disclosure-block">
        <h2>Sponsored listings</h2>
        <p>
          Tools can pay to be marked as <em>Featured</em> ($49 / 30 days) or{' '}
          <em>Sponsored</em> ($199 / 30 days). When a listing is sponsored, it carries a
          visible <span className="badge sponsored">Sponsored</span> or{' '}
          <span className="badge featured">Featured</span> badge on its detail page and
          in the tree.
        </p>
        <p>
          We reserve the right to reject any paid listing that doesn&apos;t meet our editorial
          standards, and to remove any sponsored placement at any time. Payment does not
          buy a positive review or better SEO within the tree — only the badge and
          placement time window purchased.
        </p>
      </section>

      <section className="disclosure-block">
        <h2>How ranking works</h2>
        <p>Order within a category is determined by, in this priority:</p>
        <ol>
          <li>Whether a listing is currently sponsored (sponsored listings pin to the top of their category during the paid window)</li>
          <li>Editor&apos;s Pick badge (curated by us)</li>
          <li>Popularity score (clicks + views + saves + shares + rating)</li>
          <li>Trending score (recent activity)</li>
          <li>Alphabetical fallback</li>
        </ol>
        <p>Categories, badges, and search results are otherwise algorithmic and unbiased.</p>
      </section>

      <section className="disclosure-block">
        <h2>What we track</h2>
        <p>
          When you click a tool&apos;s outbound link (the <code>/go/&lt;slug&gt;</code> redirect),
          we record: the tool clicked, timestamp, an anonymized referrer, browser device
          type, and country (derived from your IP). We do <strong>not</strong> record
          your IP address in click history or link it to any personally identifying
          information.
        </p>
        <p>
          When you view a tool detail page, we record a page view count. When you save
          or share a tool, we record those aggregate counters. None of this is linked to
          a user identity.
        </p>
      </section>

      <section className="disclosure-block">
        <h2>Newsletter</h2>
        <p>
          If you subscribe to our newsletter, we store your email address for the sole
          purpose of sending you weekly digests of new AI resources. You can unsubscribe
          at any time using the link in every email. We never sell or share your email.
        </p>
      </section>

      <section className="disclosure-block">
        <h2>Editorial independence</h2>
        <p>
          Reviews, descriptions, and category placement are written by our editors,
          not by the tool vendors themselves. If you spot an inaccuracy, please let us know.
        </p>
      </section>

      <section className="disclosure-block">
        <h2>Removal &amp; corrections</h2>
        <p>
          If you own a tool listed here and want the listing updated, corrected, or
          removed, email <a href="mailto:hello@ai-framework.io">hello@ai-framework.io</a>{' '}
          from a verifiable address at the tool&apos;s domain. We respond to takedown and
          correction requests within 3 business days.
        </p>
      </section>

      <section className="disclosure-block">
        <h2>Legal note</h2>
        <p>
          Trademarks and product names shown belong to their respective owners. AI
          Framework is an independent directory and is not affiliated with, endorsed by,
          or sponsored by any of the tools listed (except where a listing is explicitly
          marked as sponsored).
        </p>
      </section>

      <p className="muted" style={{ marginTop: 32 }}>
        Questions or feedback? Email us at{' '}
        <a href="mailto:hello@ai-framework.io">hello@ai-framework.io</a>.
      </p>
    </div>
  );
}
